import { LinkRoute } from '@/components/common/Link'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type Dict } from '@/defs/misc'
import { type QuickLinkType } from '@/defs/nav'
import { useRandomLink } from '@/hooks/useRandomLink'
import { trackEvent } from '@/utils/analyticsUtil'

type Props = {
  item: Extract<QuickLinkType, { href: string }>
  styles: Dict<string>
}

export const TopBarQuickLinkRandom = ({ item: { href, icon, label, superscript }, styles }: Props) => {
  const { loading, onClick } = useRandomLink()

  return (
    <LinkRoute
      aria-busy={loading || undefined}
      className={styles.button}
      href={href}
      onClick={(e) => {
        trackEvent({ action: 'nav_click', category: 'topbar', label: href })
        onClick(e)
      }}
    >
      <IconWithLabel iconBefore={loading ? 'spinner' : icon}>{label}</IconWithLabel>
      {superscript && <sup>{superscript}</sup>}
    </LinkRoute>
  )
}
